import BaseService from '@/services/services/tools/baseService';
import SetupParamsApi from '@/services/api/internal/heatingIgnition/setup-params.api';
import { getEntityIdFromNavFullId } from '@/business/utils/display';

const SetupParamsService = new BaseService({
  api: SetupParamsApi,
  treatListResponse: (val) => {
    return val.data.data.map((el) => ({
      ...el,
      id: el.property.id,
      code: el.property.code,
      shortname: el.property.shortname,
      entity_id: getEntityIdFromNavFullId(el.property.nav_full_id),
    }));
  },
});
SetupParamsService.updateSetupParams = function updateSetupParams(item) {
  const { id } = item;
  const param = { ...item };
  delete param.id;
  return this.api.patchItem(param, id);
};

SetupParamsService.deleteItem = function deleteItem(id) {
  return this.api.deleteItem(id);
};

export default SetupParamsService;
